import Cookie from 'js-cookie'

export const role = Cookie.get('role')
export const token_user = Cookie.get('token_user')
export const token_leads = Cookie.get('token_leads')
// export const session_time = Cookie.get('sessionTime')